import { h } from 'preact';

export default function SelectFilter({ label, name, value, choices, onChangeHandler }) {
	function onChange(event) {
		if (typeof onChangeHandler === 'function') {
			onChangeHandler(name, event.target.value);
		}
	}

	return (
		<div class={`filter-container select-filter-container filter-container-${name.replace(/\s/g, '-').toLowerCase()}`}>
			<fieldset class="filter-fieldset-container select-filter-filter-container">
				<span>{label}</span>
				{choices.length > 0 ?
					<div class="filter-choices-container">
						<select onChange={onChange} value={value} id={name} name={name}>
							<option value="" selected={value === null}>Maak een keuze</option>
							{choices.map(choice => (
								<option key={choice.value} value={choice.value} selected={value === choice.value}>{choice.text}</option>
							))}
						</select>
					</div>
					: ''}
			</fieldset>
		</div>
	);
}
